import { cn } from '@sparkai/utils'

import { Icon, IconsName } from '../../Icon'

export function Avatar({
  color,
  icon,
  size,
}: {
  color: 'red' | 'green'
  icon: IconsName
  size: 'small' | 'large'
}) {
  const colors = {
    red: {
      bg: 'bg-red-100',
      icon: 'text-red-700 h-2 w-2',
    },
    green: {
      bg: 'bg-green-100',
      icon: 'text-green-700 h-2 w-2',
    },
  } as const

  return (
    <div
      className={cn(
        'absolute -right-[5px] -bottom-[5px] flex items-center justify-center rounded-full border-2 border-white bg-red-400 lg:-right-[2px] lg:-bottom-[2px]',
        colors[color].bg,
        {
          'h-3 w-3': size === 'small',
          'h-4 w-4': size === 'large',
        }
      )}
    >
      <Icon name={icon} className={cn(colors[color].icon)} />
    </div>
  )
}
